import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../_services/auth/auth.service';

/**
 * Interceptor HTTP que adjunta el token de autenticación a cada petición saliente.
 *
 * Obtiene el JWT actual desde el {@link AuthService} y lo añade en la cabecera
 * `Authorization` de una copia de la petición, dejando la original sin modificar.
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
  ) {}

  /**
   * Intercepta la petición saliente y le agrega la cabecera `Authorization` con el token actual.
   * @param request - Petición HTTP saliente a interceptar.
   * @param next - Manejador que continúa la cadena de interceptores.
   * @returns Flujo observable con los eventos HTTP de la petición ya autenticada.
   */
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authToken = this.authService.getToken();

    const authRequest = request.clone({
      setHeaders: {
        Authorization: `${authToken}`
      }
    });

    return next.handle(authRequest);
  }
}
